const RenderSwitch = ({conds = [], children = [], _default = <></>}) => {
    const index = conds.findIndex((cond) => cond);

    if (index === -1) return _default;
    else return children[index];
};

export default RenderSwitch;
